export default {
  // Nav
  "nav.home": "Home",
  "nav.products": "Products",
  "nav.spreadsheet": "Spreadsheet",
  "nav.categories": "Categories",
  "nav.guides": "Guides",
  "nav.shoppingGuide": "Shopping Guide",
  "nav.mainSite": "Main Website",
  "nav.about": "About",
  "nav.contact": "Contact",
  "nav.disclaimer": "Disclaimer",
  "nav.language": "Language",

  // Hero
  "hero.badge": "Independent Resource · Updated 2026",
  "hero.title": "CSSBuy Spreadsheet: Find Links, Guides & Resources to Shop Smarter",
  "hero.subtitle": "Explore the CSSBuy Spreadsheet, discover popular categories, find useful resources and learn how to verify products, QC, measurements, warehouse and shipping before buying.",
  "hero.cta1": "Explore CSSBuy Spreadsheet",
  "hero.cta2": "Buy It Now",
  "hero.trust1": "Independent Resource",
  "hero.trust2": "Updated Guides 2026",
  "hero.trust3": "Organized Research",
  "hero.trust4": "Safety Information",

  // Categories dropdown
  "nav.categories.label": "Categories",
  "cat.shoes": "Shoes",
  "cat.hoodies": "Hoodies / Sweaters",
  "cat.tshirts": "T-Shirts",
  "cat.jackets": "Jackets",
  "cat.pants": "Pants / Shorts",
  "cat.headwear": "Headwear",
  "cat.sets": "Sets",
  "cat.underwear": "Underwear / Underpants",
  "cat.jersey": "Jersey",
  "cat.accessories": "Accessories",
  "cat.bags": "Bags",
  "cat.belts": "Belts",
  "cat.perfumes": "Perfumes",
  "cat.other": "Other Stuff",

  // Products page
  "products.title": "Product Catalog",
  "products.subtitle": "Explore our curated collection of products. Click any item to view details and purchase.",
  "products.allCategories": "All Categories",
  "products.searchPlaceholder": "Search products...",
  "products.clear": "Clear",
  "products.showing": "Showing",
  "products.items": "items",
  "products.noResults": "No products found",
  "products.viewAll": "View All Products",
  "what.title": "What Is the CSSBuy Spreadsheet?",
  "what.text": "A CSSBuy Spreadsheet organizes links, products, categories and shopping resources into an easy-to-search format. Our goal is to help buyers find information and make more informed decisions. This is an independent resource not affiliated with CSSBuy.",
  "what.disclaimer": "This website is an independent informational resource and is not affiliated with, endorsed by, or operated by CSSBuy.",

  // Categories section
  "cats.title": "Find What You're Looking For",
  "cats.subtitle": "Browse popular categories in the CSSBuy Spreadsheet",
  "cats.viewAll": "View All",
  "cats.explore": "Explore",

  // Why section
  "why.title": "Why Use Our CSSBuy Spreadsheet?",
  "why.1": "Organized links by category",
  "why.2": "Simple and intuitive categories",
  "why.3": "Beginner-friendly guides",
  "why.4": "QC explained step by step",
  "why.5": "Shipping explained clearly",
  "why.6": "Warehouse explained",
  "why.7": "Useful comparisons",
  "why.8": "Safety tips and guidance",

  // How it works
  "how.title": "How Does It Work?",
  "how.1.title": "Find a Category",
  "how.1.text": "Browse through CSSBuy Spreadsheet categories.",
  "how.2.title": "Search Products",
  "how.2.text": "Find links and product information.",
  "how.3.title": "Verify the Links",
  "how.3.text": "Check links, information and available details.",
  "how.4.title": "Check Measurements & QC",
  "how.4.text": "Verify measurements, QC photos and specs.",
  "how.5.title": "Compare Options",
  "how.5.text": "Compare products, prices and sellers.",
  "how.6.title": "Confirm the Data",
  "how.6.text": "Confirm current information before purchasing.",

  // Popular guides
  "guides.title": "Popular Guides",
  "guides.subtitle": "Essential resources for CSSBuy Spreadsheet buyers",
  "guides.review": "CSSBuy Review",
  "guides.review.desc": "Independent complete analysis covering QC, warehouse and shipping.",
  "guides.shipping": "CSSBuy Shipping Cost",
  "guides.shipping.desc": "Complete guide on costs, methods and shipping factors.",
  "guides.qc": "CSSBuy QC Guide",
  "guides.qc.desc": "How to verify QC photos, measurements and product quality.",
  "guides.warehouse": "CSSBuy Warehouse Guide",
  "guides.warehouse.desc": "Understanding the warehouse, storage and consolidation process.",
  "guides.legit": "Is CSSBuy Legit?",
  "guides.legit.desc": "Independent analysis of safety, payment and reliability.",
  "guides.coupon": "CSSBuy Coupon",
  "guides.coupon.desc": "Guide to coupons, promotions and discount codes.",
  "guides.readmore": "Read More",
  "pillars.title": "Detailed Guides & Articles",
  "pillars.subtitle": "In-depth resources on QC, shipping, warehouse, safety and more for CSSBuy buyers.",

  // CTA section
  "cta.title": "Find Your Next Resource in the CSSBuy Spreadsheet",
  "cta.subtitle": "Visit the main website to explore all available products and categories.",
  "cta.btn1": "Explore CSSBuy Spreadsheet",
  "cta.btn2": "cssbuy spreadsheet",
  "cta.btn3": "buy it now",

  // Safety
  "safety.title": "Safety First",
  "safety.text": "Verify links, sellers, measurements, QC, costs and current policies. Never share your password and confirm important information directly on the corresponding platform.",
  "safety.btn": "View Safety Guide",
  "safety.disclaimer": "This website is an independent informational resource. CSSBuy, sellers, marketplaces and external links are operated by their respective parties. Information, prices, availability and policies may change.",

  // FAQ
  "faq.title": "Frequently Asked Questions",
  "faq.1.q": "What is CSSBuy Spreadsheet?",
  "faq.1.a": "CSSBuy Spreadsheet is an organized spreadsheet with links, products, categories and shopping resources. This is an independent resource created to help buyers find useful information.",
  "faq.2.q": "How do I use CSSBuy Spreadsheet?",
  "faq.2.a": "Browse the categories, find relevant links and information, check details like QC and measurements, then visit the main website to confirm and complete your purchase.",
  "faq.3.q": "Is CSSBuy Spreadsheet official?",
  "faq.3.a": "No. This website is an independent informational resource and is not affiliated with, endorsed by, or operated by CSSBuy.",
  "faq.4.q": "How do I verify a link?",
  "faq.4.a": "Always access links directly and verify seller authenticity on the corresponding platform before making any purchase.",
  "faq.5.q": "How does QC work?",
  "faq.5.a": "QC (Quality Check) are photos of the product taken at the warehouse before shipping. They allow you to verify quality, measurements and item condition.",
  "faq.6.q": "How much does shipping cost?",
  "faq.6.a": "Costs vary depending on weight, volume, destination and shipping method. Always confirm the final price before payment.",
  "faq.7.q": "Is CSSBuy legit?",
  "faq.7.a": "This website presents independent information about CSSBuy to help buyers make informed decisions. Always verify current information directly on the platform.",
  "faq.8.q": "Are there CSSBuy coupons?",
  "faq.8.a": "Coupons and promotions are managed by CSSBuy. Check our Coupon Guide for more information and verify current availability directly on the platform.",

  // Footer
  "footer.desc": "Independent informational resource about CSSBuy Spreadsheet. Not affiliated with CSSBuy.",
  "footer.links": "Useful Links",
  "footer.categories": "Categories",
  "footer.legal": "Legal",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms of Use",
  "footer.disclaimer": "Disclaimer",
  "footer.about": "About",
  "footer.contact": "Contact",
  "footer.copyright": "© 2026 cssbuybr.sbs — Independent Resource. Not affiliated with CSSBuy.",
  "footer.independent": "Independent resource · Not affiliated with CSSBuy",

  // Article page
  "article.backHome": "← Back to Home",
  "article.toc": "Table of Contents",
  "article.author": "cssbuybr.sbs Editorial Team",
  "article.updated": "Updated on",
  "article.disclaimer": "Disclaimer: This content is independent and informational. We are not affiliated with CSSBuy.",
  "article.readTime": "min read",

  // About
  "about.title": "About cssbuybr.sbs",
  "about.text1": "cssbuybr.sbs is an independent informational resource focused on CSSBuy Spreadsheet. Our goal is to help buyers find organized information, useful guides and resources to make more informed purchasing decisions.",
  "about.text2": "This website is not affiliated with, endorsed by, or operated by CSSBuy. All information is based on independent public research.",
  "about.mission": "Our Mission",
  "about.missionText": "To provide organized, accurate and useful resources about CSSBuy Spreadsheet for buyers around the world.",
  "about.disclaimer": "Legal Disclaimer",
  "about.disclaimerText": "This website is an independent informational resource and is not affiliated with, endorsed by, or operated by CSSBuy.",
};